export default __webpack_public_path__ + "static/media/step_G_1_EN.ffe6ac3b.png";